module.exports = __webpack_public_path__ + "img/connect1.9155d797.jpg";